import { render } from "./RolesSettings.vue?vue&type=template&id=e693c33a&scoped=true"
import script from "./RolesSettings.vue?vue&type=script&lang=js"
export * from "./RolesSettings.vue?vue&type=script&lang=js"

import "./RolesSettings.vue?vue&type=style&index=0&id=e693c33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e693c33a"]])

export default __exports__